import {withShade} from '@dropbox/dig-foundations';

/**
 * The hover fill for a row whose hover the caller tracks itself (e.g. with
 * useExclusiveHover, so only the innermost of nested rows lights): DIG's
 * withShade in the rows' State 1 tint, on at once rather than wiping in.
 * Put the className and style on the row (merged with its own); the shade makes
 * it position: relative and clips it. A row with a fill of its own (selected)
 * should pass false, so the fills don't stack.
 */
export const useHoverShade = (hovered: boolean) =>
  withShade({
    state: hovered ? 'hover' : 'default',
    duration: 'Instant',
    bgColors: {base: 'Opacity Surface - State 1'},
  });
